module.exports = __webpack_public_path__ + "img/best-pricing-p-800.09ba3ec4.png";